import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {removeLastConstructionPlanEntry} from '../../../redux/actions';
import {selectConstructionPlanEntries} from '../../../redux/reducers/privateStateReducer/selectors';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {MASKED_ICON_TONES, MaskedIcon} from '../../coloredIcons/MaskedIcon/MaskedIcon';
import {GAME_BUTTON_SIZES, GAME_BUTTON_VARIANTS, GameButton} from '../../gameUi/GameButton';

/**
 * Отмена последнего запланированного строения — в чужой ход при планировании
 * строительства. Отдельная кнопка, а не режим UndoButton: та откатывает
 * настоящие строения хода, а в чужой ход это строения ходящего игрока
 */
const PlanUndoButton = () => {
  const dispatch = useDispatch();
  const entries = useSelector(selectConstructionPlanEntries);
  const enabled = entries.length > 0;

  const handleUndo = () => {
    if (!enabled) {
      return;
    }
    REGISTRY_SINGLETON.getSoundManager()?.playUndoClick();
    dispatch(removeLastConstructionPlanEntry());
  };

  return (
    <GameButton
      variant={GAME_BUTTON_VARIANTS.SUNK}
      size={GAME_BUTTON_SIZES.ICON}
      onClick={handleUndo}
      className={'footer-heading-btn'}
      disabled={!enabled}
      title={'Отменить последнее запланированное строение'}
    >
      <MaskedIcon
        src={'/img/icons/return.png'}
        alt={'Undo'}
        tone={MASKED_ICON_TONES.CONTROLS}
      />
    </GameButton>
  );
};

export default PlanUndoButton;
